import { parseOrThrow } from "_shared/_utilities/zod-schema-parser";
import { NetworkDomainSchema } from "_shared/network-domain/network-domain-schema";

export default class NetworkDomain {
  public readonly value: string;

  public constructor(value: string) {
    parseOrThrow(
      NetworkDomainSchema, 
      value, 
      { 
        logError: true,
        schemaName: "NetworkDomainSchema",
        operation: "constructing NetworkDomain",
        payloadSample: value 
      }
    );
    this.value = value.toLowerCase().replace(/^[^@]+@/, "");
  }

  public isEqualTo(other: NetworkDomain): boolean {
    return this.value.toLowerCase() === other.value.toLowerCase();
  }
}
